import { Injectable } from '@angular/core';
import { Observable, tap, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SnackBarService } from '../services/snack-bar-service.service';
import { IBloqueioRequest, IBloqueios } from './model/bloqueio.model';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from '../services/localstorage.service';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class CentralBloqueiosService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  public usuario!: LoginModel;


  constructor(private http: HttpClient,
    private localStorageService: LocalStorageService,
    private snackBar: SnackBarService) {

    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  
  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }

  obterDashBoard(data: IBloqueioRequest): Observable<IBloqueios>{
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaCentralBloqueios;

    return this.http.post<IBloqueios>(url, data, this.httpOptions).pipe(
        tap(response => {
          if (response && !response.sucesso) {
            this.snackBar.flashMessage('Não foi possível obter os dados da central de bloqueios.', ['snackbar-error'], 'Fechar', 0);
          }
        }),
        catchError(this.handleError<IBloqueios>('Não foi possível obter os dados da central de bloqueios.', {sucesso : false, retorno: [], mensagens: []}))
      );
  }
  
}
